import { useParams } from "react-router-dom";
import Season from "../components/Season";
import { Mode } from "../lib/globalEnums";
import { useEffect, useState } from "react";

export default function Home() {
  const { yearParam } = useParams();
  const [year, setYear] = useState(parseInt(yearParam + '', 10) || new Date().getFullYear());
  useEffect(() => {
    setYear(parseInt(yearParam + '', 10) || new Date().getFullYear())
  }, [yearParam])
  return (
    <div className="w3-container">
      <h2>Informationen</h2>
      <p>Im Jahr {year} gab es folgende Rennwochenenden.</p>
      <Season year={year} mode={Mode.extended} />
    </div>
  );
}
